module.exports = __webpack_public_path__ + "static/media/1.19fd6363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80026/1.jpg
// module id = 723
// module chunks = 0